import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { ContactInterface, GetAllContactsResponse } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  constructor(private _http: HttpClient) { }
  public contact!: ContactInterface | null;

  public updateContactLogo(image: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', image);
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
      enctype: 'multipart/form-data',
    });
    return this._http.post<string>(
      `${environment.baseUrl}/Contact/updateContactLogo`,
      formData,
      { ...headers }
    );
  }

  public updateContact(contact: ContactInterface) {
    return this._http.post<ContactInterface>(
      `${environment.baseUrl}/Contact/updateContact`,
      contact
    );
  }

  public getContact(): Observable<ContactInterface> {
    return this._http
      .get<ContactInterface>(`${environment.baseUrl}/Contact/getUserContact`)
      .pipe(tap((item) => (this.contact = item)));
  }

  public getContactLogo(): Observable<string> {
    if (!environment.logoEnabled)
      return of('');
    return this._http.get<string>(
      `${environment.baseUrl}/Contact/getContactLogo`
    );
  }

  public getContactById(id: number): Observable<ContactInterface> {
    return this._http.get<ContactInterface>(
      `${environment.baseUrl}/Contact/GetContactById`,
      { params: { id } }
    );
  }

  public getAllContacts(): Observable<GetAllContactsResponse[]> {
    return this._http.get<GetAllContactsResponse[]>(
      `${environment.baseUrl}/Contact/GetAllContacts`
    );
  }

  public deleteContactById(id: number) {
    return this._http.delete(
      `${environment.baseUrl}/Contact/DeleteNewContact`,
      { params: { id } }
    );
  }

  public removeUserContact(contactId: number): Observable<void> {
    return this._http.get<void>(`${environment.baseUrl}/Contact/RemoveUser`, {
      params: { contactId },
    });
  }

  public getContactIconById(contactId: number) {
    return this._http.get<void>('/Contact/getContactIcon', {
      params: { contactId },
    });
  }

  public addNewContact(contact: FormData): Observable<number> {
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
      enctype: 'multipart/form-data',
    });
    return this._http.post<number>(
      `${environment.baseUrl}/Contact/AddUpdateNewContact`,
      contact,
      { ...headers }
    );
  }
}
